import { useRef } from "react";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { ScrollTruck } from "@/components/ScrollTruck";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { TruckDriveBy } from "@/components/TruckCameo";
import { Hero } from "@/sections/Hero";
import { About } from "@/sections/About";
import { Services } from "@/sections/Services";
import { Fleet } from "@/sections/Fleet";
import { Coverage } from "@/sections/Coverage";
import { Industries } from "@/sections/Industries";
import { Stats } from "@/sections/Stats";
import { GalleryPreview } from "@/sections/GalleryPreview";
import { TestimonialsPreview } from "@/sections/TestimonialsPreview";
import { Contact } from "@/sections/Contact";

export default function HomePage() {
  const journeyRef = useRef(null);

  return (
    <div data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <TruckDriveBy direction="rtl" />
        <About />
        <TruckDriveBy />
        <Services />
        <Fleet />
        <Coverage />
        <div ref={journeyRef}>
          <Industries />
          <Stats />
          <GalleryPreview />
          <TestimonialsPreview />
          <Contact />
        </div>
      </main>
      <Footer />
      <ScrollTruck targetRef={journeyRef} />
    </div>
  );
}
